import React, { useState, useEffect, useContext } from 'react';
import OnceFooter from "./../common/Footer/OnceFooter";
import { useParams } from 'react-router-dom';
import api from './../../utils/api';
import { AppContext } from "./../context/ContextProvider";
import { Modal, Button, Row, Col, Form, Nav, Tab } from 'react-bootstrap';
import { numberFormat, inputKeyPressOnlyNumber } from './../../utils/functions';
import { toast } from 'react-toastify';
import moment from "moment";
import 'moment/locale/th'
import _ from "lodash";
import ReactGA from 'react-ga4';

export default function BookingStatus() {
  const { id, code } = useParams();
  const [booking, setBooking] = useState({});
  const { hotel, room, campZoneItem, campZone, roomFlexible } = booking
  const [filterCode, setFilterCode] = useState(code || '');
  const [filterTel, setFilterTel] = useState('');

  const endDate = new Date(booking?.end_date)
  const endDateStr = endDate.setDate(endDate.getDate() + 1)

  const [addons, setAddons] = useState([]);
  const [items, setItems] = useState([]);

  const addonsText = addons.map((x) => { return `${x?.addons_type?.name_th} (${x?.qty})` })
  const addonsTextStr = (addonsText || []).join(', ')
  const addonsSum = _.sumBy(addons || [], (x) => { return Number(x.total_price || 0) }) || 0

  const bookingDatesStr = (booking?.room_id || booking?.room_flexible_id) ? items.map((b) => `${moment(b.date).format('DD/MM/YYYY')} (${numberFormat(b.unit_total_price, true)})`).join(', ') :
    items.map((b) => `${moment(b.date).format('DD/MM/YYYY')} (${numberFormat((Number(b.unit_total_price || 0) + Number(b.extra_price || 0)), true)})`).join(', ')

  const [policies, setPolicies] = useState([]);
  const [foods, setFoods] = useState([]);
  const [attractions, setAttractions] = useState([]);

  const fetchBookingData = () => {
    api.request(`bookings/findonebooking`, (data) => {
      setBooking(data || {})
      setItems(data?.booking_items || [])

      if (data.booking_addons && data.booking_addons.length) {
        setAddons(data.booking_addons.map((a) => {
          return {
            ...a,
            addons_id: a.addons_id,
            total_price: a.total_price || 0,
            qty: a.qty || 0
          }
        }))
      }

      if (!!data?.id) {
        ReactGA.send({ hitType: "pageview", page: `${data?.hotel?.code}/bookingstatus`, title: `${data?.hotel?.name_th}-${data?.room_id ? data?.room?.name_th : 'camping'} BookingStatus` });

        ReactGA.event({
          category: "BookingProcess",
          action: `${data?.hotel?.code}_${data?.room_id ? data?.room?.room_no : 'camping'}_booked`,
          label: `Booking Status Success - ${data?.hotel?.code}-${data?.room_id ? data?.room?.room_no : 'camping'}`,
        });
      }

      if (data?.hotel?.show_hotel_info_to_customer) {
        fetchRecommentPlaces(data?.hotel_id);
        fetchPolicies(data?.hotel_id, (data?.room_id || null), !!data?.is_walkin, data?.close_zone_type === 'all');
      }
    }, {
      id: id,
      booking_no: filterCode,
      tel: filterTel
    })
  }

  const fetchPolicies = (_hotel_id, _room_id = null, with_walkin = false, with_close_all = false) => {
    if (!_hotel_id) return;

    let params = {
      hotel_id: _hotel_id,
      enabled: true,
      types: ['hotel_policy']
    }

    if (with_walkin) {
      params.types.push('camping_policy')
    }

    if (with_close_all) {
      params.types.push('closeall_policy')
    }

    if (!!_room_id) {
      params.types.push('room_policy')
      params.with_room_ids = [_room_id]
    }

    api.request(`hotels/hotel-info/all`, (data) => {
      if (!data || data.length === 0) {
        setPolicies([]);
        return;
      }

      setPolicies(data);
    }, params)
  }

  const fetchRecommentPlaces = (_hotel_id) => {
    if (!_hotel_id) return;

    api.request(`hotels/recommend-nearby-places/all`, (data) => {
      if (!data || data.length === 0) {
        setFoods([]);
        setAttractions([]);
        return;
      }

      const foodsData = data.filter((d) => d.type === 'food') || [];
      const attractionsData = data.filter((d) => d.type === 'attraction') || [];

      setFoods(foodsData);
      setAttractions(attractionsData);
    }, {
      hotel_id: _hotel_id,
      enabled: true,
    })
  }

  useEffect(() => {
    if (!!id) {
      fetchBookingData()
    }
  }, [id, filterCode, filterTel])

  const checkReceiptFile = (_path) => {
    if (!_path) return null

    const lowerPath = _path.toLowerCase()
    if (lowerPath.endsWith('.png') || lowerPath.endsWith('.jpg') || lowerPath.endsWith('.jpeg')) {
      return 'image'
    } else if (lowerPath.endsWith('.pdf')) {
      return 'pdf'
    }
  }

  const warningMsg = `ขณะนี้ระบบ "Once In Memory" ${booking?.payment_state === 'complete' ? 'ได้จัดส่งใบเสร็จรับเงิน' : 'ได้รับข้อมูลการจองห้องพักจากท่านแล้ว โดยเราได้ส่งรายละเอียดถึงท่าน'}ผ่านทาง SMS และอีเมล กรุณาตรวจสอบข้อมูลด้วยนะคะ`
  const outstanding = booking.payment_type === 'full' ? 0 : (Number(booking.net_total || 0) - Number(booking.paid_amount || 0))

  const roomDeposit = !!booking.room_deposits && booking.room_deposits.length > 0 ? booking.room_deposits[0] : null

  const isCloseAll = booking.close_zone_type === 'all'
  const areaName = isCloseAll ? 'จองทุกห้อง' : !!campZoneItem ? `[${campZone?.name_th}] : ${campZoneItem?.name_th}` : (room?.name_th || roomFlexible?.name_th || booking?.campType?.name_th || 'เช่าพื้นที่กางเต็นท์/Car Camp/Walk - In')

  const isCamping = booking.is_walkin

  let roomItemNames = ''
  const bookingRoomItems = booking.booking_room_items || []

  if (bookingRoomItems > 0) {
    const names = (bookingRoomItems.filter((x) => !!x.item_id) || []).map((b) => { return b.roomItem?.name_th })
    roomItemNames = names.length > 0 ? names.join(', ') : ''
  }

  const additionalPrice = Number(booking.additional_guest_total_price || 0)
  const addtiionalPet = booking.booking_additional_pets && booking.booking_additional_pets.length > 0 ? booking.booking_additional_pets[0] : null;

  const hotelPolicy = policies.find((p) => p.type === 'hotel_policy') || null;
  const campingPolicy = policies.find((p) => p.type === 'camping_policy') || null;
  const closeAllPolicy = policies.find((p) => p.type === 'closeall_policy') || null;
  const roomPolicy = policies.find((p) => p.type === 'room_policy') || null;

  const [placeHtmlDataForShow, setPlaceHtmlDataForShow] = useState(null);

  const bookingOverviewSection = () => {
    return (
      <Row>
        {!!booking.receipt_file_path && <Col xs={12} className="mb-3">

          <Button variant="success" size="sm" onClick={() => {
            window.open(booking.receipt_file_path, '_blank')
          }}>ดาวน์โหลด{booking.payment_state === 'complete' ? 'ใบเสร็จรับเงิน' : 'ใบยืนยันการจอง'}</Button>
        </Col>}
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12}>
              <span className="title">ห้องพัก/โซน : </span>
              <span className="detail">{areaName}</span>
            </Col>
            {!!roomFlexible && <Col xs={12}>
              <span className="title">จำนวนห้องที่จอง : </span>
              <span className="detail">{booking.booking_room_items?.length} ห้อง</span>
              <span className="text-muted ms-2">{roomItemNames}</span>
            </Col>}
            <Col xs={12}>
              <span className="title">วันที่เข้าพัก : </span>
              <span className="detail">{moment(booking?.start_date).format('DD/MM/YYYY')} - {moment(endDateStr).format('DD/MM/YYYY')} ({booking?.day_qty} คืน)</span>
            </Col>
            {!isCamping && <Col xs={12}>
              <span className="title">ผู้เข้าพัก : </span>
              <span className="detail">ผู้ใหญ่ {numberFormat(booking.guest_qty, true)} ท่าน, เด็กไม่เกิน {hotel?.custom_guest_baby_age || 6} ปี {numberFormat(booking.guest_baby_qty, true)} ท่าน</span>
            </Col>}
            {!isCamping && additionalPrice > 0 && <Col xs={12}>
              <span className="title">ผู้เข้าพัก (เสริม) : </span>
              <span className="detail text-danger">ผู้ใหญ่ {numberFormat(booking.additional_guest_qty, true)} ท่าน, เด็กไม่เกิน {hotel?.custom_guest_baby_age || 6} ปี {numberFormat(booking.additional_baby_qty, true)} ท่าน</span>
            </Col>}
            {!isCamping && addtiionalPet && <Col xs={12}>
              <span className="title">สัตว์เลี้ยง (เสริม) : </span>
              <span className="detail text-danger">{addtiionalPet.pet_type?.name_th} จำนวน {numberFormat(addtiionalPet.qty, true)} ตัว</span>
            </Col>}
            {isCamping && <Col xs={12}>
              <span className="title">ผู้เข้าพัก : </span>
              <span className="detail">ผู้ใหญ่ {numberFormat(booking.guest_qty, true)} ท่าน, เด็ก 6 - 12 ปี {numberFormat(booking.guest_child_qty, true)} ท่าน, เด็กต่ำกว่า 6 ปี {numberFormat(booking.guest_baby_qty, true)} ท่าน{booking.tent_qty > 0 ? `, จำนวนเต็นท์ ${numberFormat(booking.tent_qty, true)} หลัง` : ''}</span>
            </Col>}
            {isCamping && <Col xs={12}>
              <span className="title">ผู้เข้าพัก (เสริม) : </span>
              <span className="detail">ผู้ใหญ่ {numberFormat(booking.extra_person_qty, true)} ท่าน, เด็ก 6 - 12 ปี {numberFormat(booking.extra_child_qty, true)} ท่าน, เด็กต่ำกว่า 6 ปี {numberFormat(booking.extra_baby_qty, true)} ท่าน</span>
            </Col>}
            <Col xs={12}>
              <span className="title">ชื่อผู้ติดต่อ : </span>
              <span className="detail">{booking.contact_name}</span>
            </Col>
            {!!hotel && hotel.request_customer_tax_info_enabled && <Col xs={12}>
              <span className="title">เลขประจำตัวผู้เสียภาษี : </span>
              <span className="detail">{booking.customer_tax_id}</span>
            </Col>}
            {!!hotel && hotel.request_customer_tax_info_enabled && <Col xs={12}>
              <span className="title">ที่อยู่ในการออกใบเสร็จรับเงิน : </span>
              <span className="detail">{booking.customer_address || '-'}</span>
            </Col>}
            <Col xs={12}>
              <span className="title">หมายเลขโทรศัพท์ : </span>
              <span className="detail">{booking.contact_tel_1} {!!booking.contact_tel_2 ? `/ ${booking.contact_tel_2}` : ''}</span>
            </Col>
            <Col xs={12}>
              <span className="title">อีเมล : </span>
              <span className="detail">{booking.contact_email || '-'}</span>
            </Col>
            <Col xs={12}>
              <span className="title">ไลน์ไอดี (Line ID) : </span>
              <span className="detail">{booking.contact_line_id || '-'}</span>
            </Col>
            <Col xs={12}>
              <span className="title">ยี่ห้อรถ : </span>
              <span className="detail">{booking.customer_car_model || '-'}</span>
            </Col>
            <Col xs={12}>
              <span className="title">ทะเบียนรถ : </span>
              <span className="detail">{booking.customer_car_license_plate || '-'}</span>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6}>
          <hr className="my-2  d-block d-md-none" style={{ color: 'darkgray' }} />
          <Row>
            <Col xs={12}>
              <span className="title">ประเภทการชำระเงิน : </span>
              {booking.payment_type === 'payonstay' && <span className="badge bg-danger">ชำระวันเข้าพัก</span>}
              {booking.payment_type === 'deposit' && <span className="badge bg-danger">มัดจำ</span>}
              {booking.payment_type === 'full' && <span className="badge bg-success">ชำระเต็มจำนวน</span>}
              {(!!roomDeposit || booking.room_deposit_outstanding > 0) && <span className="badge bg-secondary ms-1">มีค่าประกัน</span>}
            </Col>
            {!!roomDeposit && <Col xs={12}>
              <span className="title">ค่าประกันที่พัก : </span>
              <span className="detail text-success">{numberFormat(roomDeposit.deposit_amount)} บาท (ชำระแล้ว)</span>
            </Col>}
            {booking.room_deposit_outstanding > 0 && <Col xs={12}>
              <span className="title">ค่าประกันที่พัก : </span>
              <span className="detail text-danger">{numberFormat(booking.room_deposit_outstanding)} บาท (กรุณาชำระวันเข้าพัก)</span>
            </Col>}
          </Row>
          <hr className="my-2" style={{ color: 'darkgray' }} />
          <Row>
            <Col xs={12}>
              <span className="title">ราคาที่พัก : </span>
              <span className="detail">{numberFormat(booking.total_price)} บาท {(items?.length > 0 && (booking.room_id || booking.room_flexible_id || booking.camp_zone_item_id) && !isCloseAll) && <small className="text-muted">- {bookingDatesStr}</small>}</span>
            </Col>
            {additionalPrice > 0 && <Col xs={12}>
              <span className="title">ราคาเสริมผู้เข้าพัก : </span>
              <span className="detail">{numberFormat(additionalPrice)} บาท</span>
            </Col>}
            {addtiionalPet && <Col xs={12}>
              <span className="title">ราคาเสริมสัตว์เลี้ยง : </span>
              <span className="detail">{numberFormat(addtiionalPet.total_price)} บาท</span>
            </Col>}
            {addonsSum > 0 && <Col xs={12}>
              <span className="title">ราคาอุปกรณ์เสริม : </span>
              <span className="detail">{numberFormat(addonsSum)} บาท</span>
            </Col>}
            <Col xs={12}>
              <span className="title">ส่วนลด : </span>
              <span className="detail">{numberFormat(booking.total_discount)} บาท</span>
            </Col>

            <Col xs={12}>
              <span className="title">ค่าที่พักชำระแล้ว : </span>
              <span className="detail text-success">{numberFormat(booking.paid_amount)} บาท</span>
            </Col>
            <Col xs={12}>
              <span className="title">ค่าที่พักค้างชำระ : </span>
              <span className={`detail ${outstanding > 0 ? 'text-danger' : ''}`}>{numberFormat(outstanding)} บาท {outstanding > 0 && <small className="text-warning"> *กรุณาชำระเงินส่วนที่เหลือในวันเข้าพัก</small>}</span>
            </Col>
          </Row>
          <hr className="my-2" style={{ color: 'darkgray' }} />
          <Row>
            {!!roomDeposit && <Col xs={12}>
              <span className="title">ยอดชำระสุทธิ : </span>
              <span className="badge bg-success">{numberFormat(Number(booking.paid_amount || 0) + Number(roomDeposit.deposit_amount || 0))} บาท</span>
            </Col>}
            {booking.room_deposit_outstanding > 0 && <Col xs={12}>
              <span className="title">ยอดชำระวันเข้าพัก : </span>
              <span className="badge bg-danger">{numberFormat(Number(outstanding || 0) + Number(booking.room_deposit_outstanding || 0))} บาท</span>
            </Col>}
            <Col xs={12}>
              <span className="title">สถานะการชำระเงิน : </span>
              {booking.payment_state === 'waiting' && <span className="badge bg-warning">รอการตรวจสอบ</span>}
              {booking.payment_state === 'waiting-approved' && <span className="badge bg-danger">ชำระเงินวันเข้าพัก</span>}
              {booking.payment_state === 'complete' && <span className="badge bg-success">ชำระเงินเรียบร้อยแล้ว</span>}
              {booking.payment_state === 'partial' && <span className="badge bg-info">ชำระเงินมัดจำเรียบร้อยแล้ว</span>}
            </Col>
          </Row>
          <div>
            <span className="title">หมายเหตุ : </span>
            <span className="detail">{booking.booking_note || '-'}</span>
          </div>
          {(addons && addons.length > 0) && <div>
            <span className="title">อุปกรณ์เสริม : </span>
            <span className="detail">{addonsTextStr || '-'}  ราคารวม {numberFormat(addonsSum)} บาท</span>
          </div>}
        </Col>
      </Row>
    )
  }

  const bookingOverviewTabs = () => {
    return (
      <Tab.Container defaultActiveKey="overview">
        <Nav variant="tabs" defaultActiveKey="overview" className="mb-3">
          <Nav.Item>
            <Nav.Link eventKey="overview">รายละเอียดการจอง</Nav.Link>
          </Nav.Item>
          {!!hotelPolicy && <Nav.Item>
            <Nav.Link eventKey="terms">{hotelPolicy.title_th || 'นโยบายการเข้าพัก'}</Nav.Link>
          </Nav.Item>}
          {!!roomPolicy && <Nav.Item>
            <Nav.Link eventKey="room_terms">{roomPolicy.title_th || 'นโยบายห้องพัก'}</Nav.Link>
          </Nav.Item>}
          {!!campingPolicy && <Nav.Item>
            <Nav.Link eventKey="camping_terms">{campingPolicy.title_th || 'นโยบายการเข้าพักแบบแคมป์ปิ้ง'}</Nav.Link>
          </Nav.Item>}
          {!!closeAllPolicy && <Nav.Item>
            <Nav.Link eventKey="closeall_terms">{closeAllPolicy.title_th || 'นโยบายการเหมาลาน'}</Nav.Link>
          </Nav.Item>}
          {foods.length > 0 && <Nav.Item>
            <Nav.Link eventKey="foods">แนะนำร้านอาหาร</Nav.Link>
          </Nav.Item>}
          {attractions.length > 0 && <Nav.Item>
            <Nav.Link eventKey="attractions">แนะนำสถานที่ท่องเที่ยว</Nav.Link>
          </Nav.Item>}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="overview">
            {bookingOverviewSection()}
          </Tab.Pane>
          {!!hotelPolicy && <Tab.Pane eventKey="terms">
            <div className="booking-term-condition" dangerouslySetInnerHTML={{ __html: hotelPolicy.detail_th }} />
          </Tab.Pane>}
          {!!roomPolicy && <Tab.Pane eventKey="room_terms">
            <div className="booking-term-condition" dangerouslySetInnerHTML={{ __html: roomPolicy.detail_th }} />
          </Tab.Pane>}
          {!!campingPolicy && <Tab.Pane eventKey="camping_terms">
            <div className="booking-term-condition" dangerouslySetInnerHTML={{ __html: campingPolicy.detail_th }} />
          </Tab.Pane>}
          {!!closeAllPolicy && <Tab.Pane eventKey="closeall_terms">
            <div className="booking-term-condition" dangerouslySetInnerHTML={{ __html: closeAllPolicy.detail_th }} />
          </Tab.Pane>}
          {foods.length > 0 && <Tab.Pane eventKey="foods">
            <Row>
              {foods.map((item, _i) => (
                <Col key={item.id} xs={12} lg={6} xl={4}>
                  <div className="d-block d-sm-flex align-items-center mt-2">
                    {!!item.image_url && <img className="rounded" style={{ width: 150 }} src={item.image_url} alt="" />}
                    {!item.image_url && <div className="text-center p-2 border rounded">
                      <i className="fal fa-images text-muted" style={{ fontSize: 20 }}></i>
                      <div><small className=" text-muted">No Image</small></div>
                    </div>}
                    <div className="ms-0 ms-sm-3 mt-2 mb-3 my-md-0">
                      <h5 className="m-0">{item.name_th}</h5>
                      {!!item.description_th && <div className="mb-0">{item.description_th}</div>}
                      {!!item.tel && <div className="mt-1 text-black">
                        <a href={`tel:${item.tel}`}>
                          <i className="fas fa-phone-alt"></i> {item.tel}
                        </a>
                      </div>}
                      {!!item.line_url && <div className="mt-1 text-success">
                        <a href={item.line_url} target="_blank" rel="noreferrer">
                          <i className="fab fa-line"></i> ติดต่อทางไลน์
                        </a>
                      </div>}
                      {!!item.google_map_url && <div className="mt-1 text-primary">
                        <a href={item.google_map_url} target="_blank" rel="noreferrer">
                          <i className="fas fa-map-marker-alt"></i> ดูแผนที่
                        </a>
                      </div>}
                      {!!item.place_link && <div className="mt-1 text-secondary">
                        <a href={item.place_link} target="_blank" rel="noreferrer">
                          <i className="fas fa-globe"></i> เว็บไซต์
                        </a>
                      </div>}
                      {!!item.detail_th && <div className="mt-1 text-secondary">
                        <Button variant="secondary" className="btn-sm mt-0" onClick={() => {
                          setPlaceHtmlDataForShow(item.detail_th)
                        }}>ดูข้อมูลเพิ่มเติม</Button>
                      </div>}
                      <hr className="d-block d-sm-none" style={{ color: 'darkgray' }} />
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Tab.Pane>}
          {attractions.length > 0 && <Tab.Pane eventKey="attractions">
            <Row>
              {attractions.map((item, _i) => (
                <Col key={item.id} xs={12} lg={6} xl={4}>
                  <div className="d-block d-sm-flex align-items-center mt-2">
                    {!!item.image_url && <img className="rounded" style={{ width: 80 }} src={item.image_url} alt="" />}
                    {!item.image_url && <div className="text-center p-2 border rounded">
                      <i className="fal fa-images text-muted" style={{ fontSize: 20 }}></i>
                      <div><small className=" text-muted">No Image</small></div>
                    </div>}
                    <div className="ms-0 ms-sm-3 mt-2 mb-3 my-md-0">
                      <h5 className="m-0">{item.name_th}</h5>
                      {!!item.description_th && <div className="mb-0">{item.description_th}</div>}
                      {!!item.tel && <div className="mt-1 text-black">
                        <a href={`tel:${item.tel}`}>
                          <i className="fas fa-phone-alt"></i> {item.tel}
                        </a>
                      </div>}
                      {!!item.google_map_url && <div className="mt-1 text-success">
                        <a href={item.google_map_url} target="_blank" rel="noreferrer">
                          <i className="fas fa-map-marker-alt"></i> ดูแผนที่
                        </a>
                      </div>}
                      {!!item.place_link && <div className="mt-1 text-secondary">
                        <a href={item.place_link} target="_blank" rel="noreferrer">
                          <i className="fas fa-info-circle"></i> รายละเอียดเพิ่มเติม
                        </a>
                      </div>}
                      <hr className="d-block d-sm-none" style={{ color: 'darkgray' }} />
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Tab.Pane>}
        </Tab.Content>
      </Tab.Container>
    )
  }

  return (
    <>
      {/* <Menu header_style_2={true} /> */}
      <div className="text-center">
        {!id && <div className=" px-5 py-3">
          <Row className="booking-form-input">
            <Col xs={6} className="ps-5 pe-2">
              <div className="text-start">
                <div>หมายเลขการจอง</div>
                <input
                  type="text"
                  placeholder="ระบุหมายเลขการจอง"
                  value={filterCode}
                  onKeyPress={inputKeyPressOnlyNumber}
                  onChange={(e) => setFilterCode(e.target.value)}
                />
              </div>

            </Col>
            <Col xs={6} className="pe-5 ps-2">
              <div className="text-start">
                <div>หมายเลขโทรศัพท์</div>
                <input
                  type="text"
                  placeholder="ระบุหมายเลขโทรศัพท์"
                  value={filterTel}
                  onKeyPress={inputKeyPressOnlyNumber}
                  onChange={(e) => setFilterTel(e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <div className="text-warning text-start ps-5 mt-2">
            <Button variant="dark" className="rounded-0 px-4 me-3" size="md" onClick={() => {
              if (!filterCode || !filterTel) {
                toast.warn('กรุณาระบุหมายเลขการจอง และหมายเลขโทรศํพท์ให้ครบถ้วน')
                return
              }

              fetchBookingData()
            }}> <i className="far fa-search"></i> ค้นหา</Button>
            <span>** กรุณาระบุหมายเลขการจอง และหมายเลขโทรศัพท์ให้ครบถ้วน</span>
          </div>
        </div>}
        {!booking?.id && <div className="p-5">
          <h4>ไม่พบข้อมูลการจองที่ค้นหา !</h4>
          <div>{!id ? 'กรุณาตรวจสอบหมายเลขการจอง หรือหมายเลขโทรศัพท์ให้ถูกต้อง' : 'กรุณาตรวจสอบลิงค์ให้ถูกต้อง หรือติดต่อผู้ดูแลระบบ'}</div>
        </div>}

        {!!booking?.id && <div className="p-5 booking-status">
          <p className="text-success text-start text-md-center">{warningMsg}</p>
          <h4>รายละเอียดการจองห้องพัก</h4>
          <div className="text-start px-2 px-md-5 py-3">
            <div className="d-flex align-items-center">
              {!!hotel?.logo_file_path && <img src={hotel?.logo_file_path} className="hotel-logo" alt="img" />}
              <h5 className="mx-2">{hotel?.name_th}</h5>
            </div>
            {hotel?.show_hotel_info_to_customer && <div>
              {bookingOverviewTabs()}
            </div>}
            {!hotel?.show_hotel_info_to_customer && <div>
              {bookingOverviewSection()}
            </div>}
          </div>
        </div>}
      </div >
      <Modal size="lg" show={!!placeHtmlDataForShow} onHide={() => setPlaceHtmlDataForShow(null)} centered>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: placeHtmlDataForShow }} />
        </Modal.Body>
      </Modal>
      <OnceFooter />
    </>
  );
}
